// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__15LM-","App-header":"App_App-header__3nnPn","mainContent":"App_mainContent__3N2BW"};